import { HeartIcon } from "@heroicons/react/24/outline";
import { useRef, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { ContentType } from "../../apiFunctions/sop/content_type";
import { editGeneration } from "../../apiFunctions/sop/utils";
import MainButton from "../../components/generic/buttons/mainButton";
import { setEditorState, setSidebarOpen } from "../../store/sop/actions";
import { classNames } from "../../utils/common";
import { useCopyToClipboard } from "usehooks-ts";
import { useRouter } from "next/router";

export interface SectionCardProps {
  text: string;
  id: string;
  handleEdit: Function;
  rating?: number;
  editorState: string;
  setOpenModal: any;
  contentType?: ContentType;
}

const SectionCard: React.FC<SectionCardProps> = ({
  text,
  id,
  rating,
  handleEdit,
  editorState,
  setOpenModal,
  contentType,
}) => {
  const [copyData, setCopyData] = useCopyToClipboard();
  const [editable, setEditable] = useState<boolean>(false);
  const router = useRouter();

  const { sopId, type } = router.query;

  const dispatch = useDispatch();
  const contentRef = useRef<HTMLDivElement>(null);
  const handleSave = () => {
    editGeneration({
      id: id,
      output: { data: { text: contentRef?.current?.innerText ?? text } },
    });
    setEditable(false);
  };
  const handleUpdate = async () => {
    setEditable(true);
  };
  const [fill, setFill] = useState(false);
  const handleRating = () => {
    let rating = 0;
    setFill(!fill);
    if (fill) {
      rating = 5;
    }
    editGeneration({
      id: id,
      rating: 5,
    });
  };

  const appendToEditor = () => {
    // todo use ref and pick text from div
    var initialText = contentRef?.current?.innerText ?? text;
    const headingsArray = [
      "Introduction",
      "Reasons for Studying in Australia",
      "Relevance to Future Plans",
      "Ties to Home Country",
      "Previous Study",
      "Conclusion",
    ];
    let formattedText = "";

    // Initialize a variable to track whether a heading is found
    let headingFound = false;

    // Iterate through the headings and paragraphs
    for (let i = 0; i < headingsArray.length; i++) {
      const heading = headingsArray[i];
      const startIndex = initialText.indexOf(heading);
      let paragraph = "";

      if (startIndex !== -1) {
        if (i < headingsArray.length - 1) {
          const nextIndex = initialText.indexOf(headingsArray[i + 1]);
          paragraph = initialText
            .slice(startIndex + heading.length, nextIndex)
            .trim();
        } else {
          paragraph = initialText.slice(startIndex + heading.length).trim();
        }

        // Remove the colon from the beginning of the paragraph
        paragraph = paragraph.replace(/^:\s*/, "");

        formattedText += `<h2><strong>${heading}</strong></h2>\n<p>${paragraph}</p>\n<br/>`;
        headingFound = true;
      }
    }

    // If no heading was found, treat the whole text as a single paragraph
    if (!headingFound) {
      formattedText += `<p>${initialText}</p>\n`;
    }

    setOpenModal(false);
    dispatch(
      setEditorState(
        editorState +
          `<h2><br/> <strong>${contentType?.title}</strong></h2> <br/> <br/> ${
            formattedText ?? initialText
          }`
      )
    );
  };
  return (
    <>
      <div
        className=" rounded-2xl text-primary-900 bg-tootler-primary-50 hover:border-primary-400 transition-all  my-4 "
        // style={{ borderColor: editable ? "#0978f6" : "#32a5cb" }}
      >
        <div className="flex justify-between border-b border-tootler-primary-400">
          <div
            contentEditable={editable}
            ref={contentRef}
            className={classNames(
              "w-full px-6 text-tootler-grey-900 py-3 tracking-wider leading-relaxed",
              editable
                ? "border-solid border-2 border-slate-300 rounded-lg p-2 "
                : ""
            )}
          >
            {text}
          </div>
          {editable && (
            <div className="w-24">
              <MainButton
                label={"SAVE"}
                isDark={true}
                onClick={handleSave}
              ></MainButton>
              <MainButton
                label={"CANCEL"}
                isDark={false}
                onClick={() => {
                  setEditable(false);
                }}
              ></MainButton>
            </div>
          )}
        </div>

        <div className="flex p-4 px-6 rounded-b-2xl justify-between bg-tootler-primary-10">
          <div onClick={handleRating} className=" text-tootler-primary-400 ">
            <HeartIcon
              className={`w-6 hover:scale-110 transition hover:fill-tootler-primary-400 hover:text-transparent ${
                fill ? "fill-tootler-primary-400 text-transparent" : ""
              }  cursor-pointer`}
            />
          </div>

          <div className="flex gap-5 text-sm font-bold">
            <button
              onClick={() => {
                setCopyData(text);
              }}
              className="cursor-pointer text-tootler-primary-400 hover:text-tootler-primary-700/70 transition"
            >
              Copy
            </button>

            {/*
            <CustomTooltip key={id} message="Edit">
              <PencilIcon
                onClick={handleUpdate}
                className="cursor-pointer h-6 w-6 text-slate-400 hover:text-slate-900"
              />
              
              
            </CustomTooltip>
            */}
            <button
              onClick={appendToEditor}
              className="cursor-pointer text-tootler-primary-900 hover:text-slate-900/70 transition-all"
            >
              Add to Editor
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    editorState: state.sop.editorState,
  };
};
export default connect(mapStateToProps)(SectionCard);
